import { isGroupedColumn } from '../kit/tables/SimpleTable/SimpleTable.utils';
export const getFlattenColumns = (columns) => {
    return columns.reduce((acc, cur) => {
        let result = acc;
        if (isGroupedColumn(cur)) {
            const visibleSubColumns = cur.items.filter((column) => !column.hidden);
            cur.items = visibleSubColumns;
            result = acc.concat(visibleSubColumns);
        }
        else {
            result.push(cur);
        }
        return result;
    }, []);
};
//# sourceMappingURL=table.utils.js.map